import * as Types from '@crimeos-frontend/crime-os/graphql'

import { gql } from '@apollo/client'
import {
  UserFragmentDoc,
  FilterFragmentDoc,
  AiCopilotConfigFragmentDoc
} from '@crimeos-frontend/crime-os/graphql-docs'
import * as Apollo from '@apollo/client'
export type GetUserAppConfigQueryVariables = Types.Exact<{
  [key: string]: never
}>

export type GetUserAppConfigQuery = {
  __typename: 'Query'
  getUserAppConfig: {
    __typename: 'UserAppConfig'
    selectedLanguage: Types.Language
    allowedFeatures: Array<Types.CrimeOsFeature>
    userDetails: {
      __typename: 'User'
      firstName?: string | null
      lastName?: string | null
      userId: string
      email?: string | null
      name?: string | null
      profilePicUrl?: string | null
      isAdmin: boolean
      designation: string
      phoneNumber?: {
        __typename: 'PhoneNumberResponse'
        dialCode: string
        iso2CountryCode?: string | null
        phoneNumber: string
      } | null
    }
    units: Array<{
      __typename: 'Unit'
      name: string
      shortName: string
      unitId: number
      logoUrl?: string | null
      stations: Array<{
        __typename: 'Station'
        name: string
        shortName: string
        stationId: number
      }>
    }>
    nodalOfficersListConfig?: {
      __typename: 'NodalOfficersListConfig'
      templateId: string
      filtersConfig: Array<{
        __typename: 'Filter'
        filterId: string
        name: string
        isMultiSelectOption: boolean
        filterOptions: Array<{
          __typename: 'FilterOption'
          name: string
          id: string
        }>
      }>
      orderedColumns: Array<{ __typename: 'ColumnConfig'; fieldId: string }>
    } | null
    aiCopilotConfig: {
      __typename: 'AICopilotConfig'
      chatAiAssistants: Array<{
        __typename: 'ChatAIAssistant'
        aiAssistantType: Types.AiAssistantType
        description?: string | null
        iconUrl?: string | null
        title: string
      }>
      attachmentsConfig: {
        __typename: 'AICopilotAttachmentConfig'
        allowedFormats: Array<string>
        maxFileSizeKb: number
        maxFileCount: number
      }
    }
    supportWidget: {
      __typename: 'SupportWidgetDetails'
      restoreId?: string | null
    }
  }
}

export const GetUserAppConfigDocument = gql`
  query getUserAppConfig {
    getUserAppConfig {
      userDetails {
        ...User
      }
      selectedLanguage
      units {
        name
        shortName
        stations {
          name
          shortName
          stationId
        }
        unitId
        logoUrl
      }
      nodalOfficersListConfig {
        templateId
        filtersConfig {
          ...Filter
        }
        orderedColumns {
          fieldId
        }
      }
      aiCopilotConfig {
        ...AICopilotConfig
      }
      allowedFeatures
      supportWidget {
        restoreId
      }
    }
  }
  ${UserFragmentDoc}
  ${FilterFragmentDoc}
  ${AiCopilotConfigFragmentDoc}
`
export type GetUserAppConfigQueryResult = Apollo.QueryResult<
  GetUserAppConfigQuery,
  GetUserAppConfigQueryVariables
>
